import React from "react";
import { NextPage } from "next";

import { WhistleblowingPage } from "scenes/Whistleblowing";

const Whistleblowing: NextPage = () => <WhistleblowingPage />;

export default Whistleblowing;
